<div class="u-padding-24">
  <div *ngIf="imageSrc" class="u-marginBottom-8 u-textAlign-center">
    <img [src]="imageSrc" alt="" [ngStyle]="{ width: '96px' }" />
  </div>
  <p
    class="color-grey-300 u-marginBottom-16 u-textAlign-center u-text-maxWidth u-margin-center"
  >
    {{ message }}
  </p>
  <div *ngIf="ctaText" fxLayout="row" fxLayoutAlign="center center">
    <button
      *ngIf="!ctaRouterLink"
      mat-stroked-button
      color="primary"
      type="button"
      (click)="ctaClick.emit()"
    >
      {{ ctaText }}
    </button>
    <a
      *ngIf="ctaRouterLink"
      mat-stroked-button
      color="primary"
      type="button"
      [routerLink]="ctaRouterLink"
    >
      {{ ctaText }}
    </a>
  </div>
</div>
